import { $, component$, type PropsOf } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

type TextareaProps = PropsOf<"textarea"> & { error?: unknown };

export const Textarea = component$<TextareaProps>(
  ({
    ["bind:value"]: valueSig,
    value,
    onInput$,
    class: className,
    maxLength,
    ...props
  }) => {
    const currentValue = valueSig ? valueSig.value : value;
    const currentLength = (currentValue as string)?.length || 0;

    return (
      <div class="w-full">
        <textarea
          class={cn(
            "input flex min-h-[120px] w-full",
            {
              "border-red-700": props.error,
            },
            className,
          )}
          value={currentValue}
          onInput$={
            valueSig ? $((_, el) => (valueSig.value = el.value)) : onInput$
          }
          maxLength={maxLength}
          {...props}
        />
        {maxLength && (
          <div class="mt-1 text-right text-sm text-gray-500">
            {currentLength}/{maxLength}
          </div>
        )}
      </div>
    );
  },
);
